import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

export const AuthGuard = ({ children }) => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { authInfo } = useSelector((store: any) => store.auth);

  useEffect(() => {
    if (!params) {
      return;
    }

    if (!authInfo.isAuthorized) {
      navigate('/auth/login');
    }
  }, [params, navigate, authInfo, location]);

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};
